// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"13e284aa","112":"9cccdb9e","255":"00b7d998","645":"d6af71ad","767":"9ae22ffb","787":"34cef3b3"}[chunkId] + ".chunk.js";
};